import React from "react";
import styles from '../../styles/educationFair.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "../CustomImage";
interface Props {
  data: any
}

const WhyChoosKcStudyAbroad: React.FC<Props> = ({ data }) => {
  return (
    <div id="whychoos-kcstudyabroad" className={styles.choosekc} style={{ background: data?.sectionBgColor || '#ffffff' }}>
      <Container>
        <div className={styles.whykc}>
          <Row>
            <div className={styles.heading}>
              <h2>{data?.sectionTitle}</h2>
            </div>
          </Row>
          <Row>
            {
              data?.pointImage?.length > 0 &&
              data?.pointImage.map((point: any) => {
                return (
                  <Col xl={4} lg={4} md={4} sm={12} xs={6}>
                    <div className={styles.box}>
                      <div className={styles.img}> <CustomImage src={point?.imageUrl} width={100} height={110} alt="Free Counselling" /> </div>
                      <div><p>{point?.title}</p></div>
                    </div>
                  </Col>
                )
              })
            }
          </Row>
        </div>
      </Container >
    </div >
  )
}

export default WhyChoosKcStudyAbroad;